import { statusLabel, statusTone } from '../utils/statusUi.js';

export function StatusBadge({ status, label, tone, dot = true }) {
  const resolvedTone = tone || statusTone(status);
  const text = label || statusLabel(status);

  return (
    <span className={`status-badge status-badge--${resolvedTone}`}>
      {dot ? <span className="status-badge-dot" aria-hidden /> : null}
      {text}
    </span>
  );
}
